import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ApiCall } from '@shared/async-services/http/api-call.service';
import storageService from '@shared/storage/storageService';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-inquiry-page',
  templateUrl: './inquiry-page.component.html',
  styleUrls: ['./inquiry-page.component.scss']
})
export class InquiryPageComponent implements OnInit {
  public inquiryForm: FormGroup;
  public submitted = false;
  selectedLanguage = "fr";
  data : any;
  accountingFirmSuccessMessage: any;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
		private translate: TranslateService,
    private auth: ApiCall,
  ) { }

  ngOnInit(): void {
    this.setLanguage();
    this.inquiryForm = this.fb.group({
      lastName: ["", [Validators.required]],
      firstName: ["", [Validators.required]],
      accountingFirmName: ["", [Validators.required]],
      telephoneNo: ["",Validators.required],
      email: ["",[Validators.required,Validators.email,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],

    });
  }

  setLanguage() {
		this.selectedLanguage = storageService.getItem("language");
		this.translate.use(this.selectedLanguage);
	}

  get formControl() {
    return this.inquiryForm.controls;
  }


  onSubmit(){
    try {
      this.submitted = true;
      if (!this.inquiryForm.valid) {
          return;
      }
      this.auth.onSubmitForm(this.inquiryForm.value).subscribe((res: any) => {
          console.log(res.message);
          this.translate.get(['INQUIRY_FORM.SUCCESS_MESSAGE'])
              .subscribe(translations => {
              this.accountingFirmSuccessMessage = translations['INQUIRY_FORM.SUCCESS_MESSAGE'];
            });
          this.toastr.success(this.accountingFirmSuccessMessage);
      }, (error) => {
          this.toastr.error('Failed to send Accounting Firm mail.');
        }, ()=> {
          this.submitted = false;
        });
      } catch (error) {
        this.toastr.error("Error while submitting inquiry form, ", error)
      }
    }
  

}
